
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/add-collection",
      function () {
        return require("private-next-pages/add-collection.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/add-collection"])
      });
    }
  